import { CartItem } from '@givebacks/api/store';

const toItemDetailString = (value: string | { values: string[] } | string[]): string => {
  if (typeof value == 'string' || typeof value == 'number') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.join(', ');
  }

  return value?.values?.join(', ') || '';
};

const isDiscountCartItem = (cartItem: CartItem) => {
  return (
    cartItem?.store_item?.type === 'StoreItems::DiscountAmount' ||
    cartItem?.store_item?.type === 'StoreItems::DiscountPercent'
  );
};

export { isDiscountCartItem, toItemDetailString };
